module.exports = __webpack_public_path__ + "static/media/balanco5.274e7369.jpeg";